<mat-tab-group animationDuration="0ms">
    <div *ngFor="let tabs of frmGroup.controls[configData.name].controls, let i = index">
        <mat-tab label="{{configData.tabs[i].label}}" class="label-class">
            <form id="overlay11" [formGroup]="frmGroup">

                <!-- when groups not direct controls -->
                <div *ngIf="configData.tabs[i].groups" class="dhl-content-v2 dhl-grid-v2 mr-0 ml-0">
                    <div *ngFor="let group of configData.tabs[i].groups;let grpIdx =index;">
                        <div *ngIf="grpIdx !== 0 && group.visibility !== false  && group.showDividerLine !== false && checkSectionAccess(group,i,grpIdx); else space" class="section-align">
                            <mat-divider class="section-divider"></mat-divider>
                        </div>
                        <ng-template #space>
                            <div *ngIf="group.visibility !== false" style="padding-top: 30px;"></div>
                        </ng-template>
                        <div *ngIf="group.label && group.visibility !== false  && checkSectionAccess(group,i,grpIdx)" class="dhl-group-title-v2">
                            {{ group.label | translate}}
                        </div>

                        <div *ngIf="group.groupLevelAction && group.visibility !== false" class="group-level-action" [ngClass]="{'disable-group-action': group.groupLevelAction.actionOnDisabled}">  
                            <span class="label" [ngClass]="{'label-action': !group.groupLevelAction.actionOnDisabled}" (click)="groupLevelActionData(group.groupLevelAction, i)">{{group.groupLevelAction.label}}</span>
                        </div>
                        
                        <div class="row">
                            <div [class.hide]="group.visibility === false || !checkSectionAccess(group,i,grpIdx) || frmGroup?.controls[configData.name]?.controls[i]?.get(control.name)['hidden']"
                                *ngFor="let control of group.controls" [ngClass]="getColsClass(control.cols, control)">
                                <app-form-field [configData]="control" [screenVersion]="configData.screenVersion"
                                    [frmGroup]="frmGroup.controls[configData.name].controls[i]"></app-form-field>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="configData.tabs[i].controls  && checkSectionAccess(configData.tabs[i].controls,i)" class="dhl-content-v2 dhl-grid-v2 mr-0 ml-0">
                    <div class="row">
                        <div *ngFor="let control of configData.tabs[i].controls"
                            [ngClass]="getColsClass(control.cols, control)">
                            <app-form-field [configData]="control" [screenVersion]="configData.screenVersion"
                                [frmGroup]="frmGroup.controls[configData.name].controls[i]"></app-form-field>
                        </div>
                    </div>
                </div>
                <mat-divider class="section-divider"></mat-divider>               
            </form>
        </mat-tab>

    </div>
</mat-tab-group>